import React from 'react';
import './TripPricing.css';

function TripPricing({ tour }) {
  const basePrice = parseInt(String(tour.price).replace(/,/g, '')) || 0;
  const highSeasonPrice = parseInt(String(tour.priceHighSeason || tour.price).replace(/,/g, '')) || basePrice;
  const peakSeasonPrice = parseInt(String(tour.pricePeakSeason || tour.price).replace(/,/g, '')) || basePrice;

  return (
    <section className="trip-pricing">
      <div className="trip-pricing-container">
        <h2 className="trip-section-title">Pricing</h2>
        
        <div className="trip-pricing-seasons">
          <div className="trip-pricing-season-card">
            <h3 className="trip-pricing-season-title">Low Season</h3>
            <div className="trip-pricing-season-price">${basePrice.toLocaleString()}</div>
            <p className="trip-pricing-season-desc">Per person</p>
          </div>
          
          <div className="trip-pricing-season-card">
            <h3 className="trip-pricing-season-title">High Season</h3>
            <div className="trip-pricing-season-price">${highSeasonPrice.toLocaleString()}</div>
            <p className="trip-pricing-season-desc">Per person</p>
          </div>
          
          <div className="trip-pricing-season-card">
            <h3 className="trip-pricing-season-title">Peak Season</h3>
            <div className="trip-pricing-season-price">${peakSeasonPrice.toLocaleString()}</div>
            <p className="trip-pricing-season-desc">Per person</p>
          </div>
        </div>

        {tour.pricing && Object.keys(tour.pricing).length > 0 && (
          <div className="trip-pricing-table">
            <h3 className="trip-pricing-table-title">Group Size Pricing</h3>
            <div className="trip-pricing-table-wrapper">
              <table className="trip-pricing-table-content">
                <thead>
                  <tr>
                    <th>Group Size</th>
                    <th>Low Season</th>
                    <th>High Season</th>
                    <th>Peak Season</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(tour.pricing).map(([size, prices]) => (
                    <tr key={size}>
                      <td>{size} {size === '2' ? 'Person' : 'People'}</td>
                      <td>${prices.low.toLocaleString()}</td>
                      <td>${prices.high.toLocaleString()}</td>
                      <td>${prices.peak.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className="trip-pricing-cta">
          <button className="btn btn-primary">Book Now</button>
          <button className="btn btn-secondary">Request Quote</button>
        </div>
      </div>
    </section>
  );
}

export default TripPricing;

